export const REGEXP = {
  fullName: new RegExp(/^[A-Za-z]+(?:\s+[A-Za-z]+)+$/i)
}



// WEBPACK FOOTER //
// ./scripts/src/shared/regexp.js